export default __webpack_public_path__ + "static/media/forward.8271aee7.svg";